import { redirect } from '@/lib/utils'
import { callApi } from './common'

function info(params) {
  return callApi('session/info', params)
}

function login(redirectUrl) {
  callApi('session/login_info', {
    redirect: redirectUrl,
  }).then((res) => {
    redirect(res.url, res.qs)
  })
}

function logout() {
  callApi('session/logout')
}

function me() {
  return callApi('session/me')
}

export default {
  info,
  login,
  logout,
  me,
}
